import styled from '../../styled-components';
import { P, Modal } from '@meindach/ui-kit';
import { Link } from 'react-router-dom';

export const StyledModal = styled(Modal)`
  max-width: 410px;
  margin: 0 auto;
`;

export const Name = styled.p`
  margin: 0;
  font-weight: 700;
  font-size: 16px;
  letter-spacing: 0.18px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: ${({ theme }) => theme.spacing.s};

  ${Name} {
    margin: 0;
    font-size: 18px;
  }
  ${P} {
    margin: 0;
    font-size: 14px;
  }
`;

export const Header = styled.div`
  padding: ${({ theme }) => theme.spacing.m};
  border-bottom: 1px solid ${({ theme }) => theme.color.mercury};

  display: flex;

  > div:last-child {
    margin-left: auto;
    padding-left: ${({ theme }) => theme.spacing.s};
    color: ${({ theme }) => theme.color.silver};
    cursor: pointer;

    > svg {
      width: 30px;
      height: 30px;
    }
  }
`;

export const Entry = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.color.mercury};
  display: flex;

  > ${P} {
    flex: 50;
    margin: ${({ theme }) => theme.spacing.s} 0;
    display: flex;
    align-items: center;

    > svg {
      margin-right: ${({ theme }) => theme.spacing.s};
      width: 25px;
      height: 25px;
    }
  }
  &:last-of-type {
    border-bottom: none;
  }
`;

export const StyledLink = styled(Link)`
  margin-left: auto;
`;

export const Details = styled.div`
  padding: ${({ theme }) => theme.spacing.s} ${({ theme }) => theme.spacing.m};
  > ${P} {
    margin: ${({ theme }) => theme.spacing.s} 0;
  }
`;

export const Links = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 0;

  > :first-child {
    margin-right: ${({ theme }) => theme.spacing.l};
  }
`;

export const Counties = styled.div`
  > * {
    margin-right: ${({ theme }) => theme.spacing.s};
    margin-bottom: ${({ theme }) => theme.spacing.s};
  }
`;
